<ng-container *transloco="let t">
  <div class="card card-xl-stretch mb-md-6">
    <div class="card-header border-0 mt-md-2 d-block">
      <h3 class="card-title fw-bold text-dark" transloco="label_article_number_and_other_codes"></h3>
      <span class="text-muted fw-semibold fs-7" transloco="paragraph_find_parts_by_number"></span>
    </div>

    <div class="card-body py-2">
      <form class="form w-100" novalidate #freeSearchForm="ngForm" (ngSubmit)="onSearch()">
        <input type="hidden" name="searchOption" [(ngModel)]="searchOption" required />

        <div class="row g-5 mb-5">
          @for (item of searchOptionList; track item?.value) {
            <div class="col-6">
              <button type="button" class="code-option-card w-100 border border-1 rounded-3 bg-light cursor-pointer p-4" [class.active]="searchOption === item?.value" (click)="onSelectSearchOption((item?.value))">
                <span class="d-block mb-3">
                  @switch (item?.value) {
                    @case (8) {
                      <i class="bi bi-upc-scan fs-2 text-muted"></i>
                    }

                    @case (6) {
                      <i class="fa-solid fa-bolt fs-2 text-muted"></i>
                    }

                    @case (7) {
                      <i class="bi bi-gear-wide-connected fs-2 text-muted"></i>
                    }

                    @case (11) {
                      <i class="bi bi-box fs-2 text-muted"></i>
                    }

                    @case (15) {
                      <i class="bi bi-search fs-2 text-muted"></i>
                    }

                    @default {
                      <i class="bi bi-search fs-2 text-muted"></i>
                    }
                  }
                </span>

                <span class="fw-bold fs-7" [transloco]="(item?.label)" [class.text-primary]="searchOption === item?.value" [class.text-dark]="searchOption !== item?.value"> </span>
              </button>
            </div>
          }
        </div>

        <div class="mb-3">
          <mat-form-field class="mat-form-field-fluid" subscriptSizing="dynamic">
            <mat-label transloco="sentence_enter_your_code_here"></mat-label>

            <input matInput name="inputText" class="text-uppercase" [(ngModel)]="inputText" required />

            @if (inputText) {
              <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="onClearInput()">
                <mat-icon>close</mat-icon>
              </button>
            }

            <mat-error transloco="sentence_please_enter_input_text_or_code"></mat-error>
          </mat-form-field>
        </div>

        <button type="submit" [disabled]="loadingAfterSearch()" class="btn btn-primary w-100 search-btn">
          @if (!loadingAfterSearch()) {
            <i class="fas fa-search me-2"></i>
          } @else {
            <span class="spinner-border spinner-border-sm me-2"></span>
          }

          <span transloco="label_search"></span>
        </button>
      </form>
    </div>
  </div>
</ng-container>
